import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { selectNeedsEmailVerification, useAuthStore } from '../store/authStore.js';
import { isReportPrintMode } from '../lib/printMode.js';

export function RequireAuth() {
  const user = useAuthStore((s) => s.user);
  const isLoading = useAuthStore((s) => s.isLoading);
  const isInitialized = useAuthStore((s) => s.isInitialized);
  const needsEmailVerification = useAuthStore(selectNeedsEmailVerification);
  const { pathname, search } = useLocation();

  // Headless PDF render: authenticated by the print token, not a user session.
  // Let it through so the report page can render under Gotenberg's Chromium.
  if (isReportPrintMode(pathname, search)) {
    return <Outlet />;
  }

  if (!isInitialized || isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-ig-bg-primary text-ig-text-secondary">
        Loading…
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Email/password accounts must activate before reaching any protected page.
  if (needsEmailVerification) {
    return <Navigate to="/verify-email" replace />;
  }

  return <Outlet />;
}
